export const MASTER_DATA_TTL_MS = 5 * 60 * 1000;

export function shouldRefreshMasterData(masterData) {
  if (!masterData?.isInitialized || !masterData?.lastFetched) return true;
  return Date.now() - new Date(masterData.lastFetched).getTime() > MASTER_DATA_TTL_MS;
}
